function onSwymLoadCallback(swat) {
  function initMain() {
    swat.initializeActionButtons("body");
    addEventListeners();
  }

  document.addEventListener("swym:collections-loaded", () => {
    initMain();
    setTimeout(initMain, 2000);
    setTimeout(initMain, 2500);
    setTimeout(initMain, 3000);
  });

  const currentLanguage = swat.retailerSettings.UI.Language
    ? swat.retailerSettings.UI.Language
    : "english";
  const swymCollectionsModal = document.getElementById(
    "swym-custom-collections-modal-background"
  );
  const desktopModalTitle = document.getElementById("swym-custom-modal-title");
  const multipleListParentContainer = document.getElementById(
    "swym-custom-multiple-list-parent-container"
  );
  const selectPreferenceText = document.getElementById(
    "swym-custom-select-preference-text"
  );
  const selectListsText = document.getElementById(
    "swym-custom-select-wishlists-text"
  );
  const createListGuideText = document.getElementById("swym-list-guide-text");
  const webpageBody = document.querySelector("body");
  const modalCloseButton = document.getElementById("swym-custom-modal-close");
  const createListModalTitle = document.getElementById(
    "swym-create-list-title"
  );
  const variantSelectionContainer = document.getElementById(
    "swym-custom-variant-selector-container"
  );
  const addToWishlistButton = document.getElementById(
    "swym-custom-add-to-wishlist-button"
  );
  const isSingleWishlist = !swat.retailerSettings.Wishlist.EnableCollections;
  const listIdContainer = document.getElementById(
    "swym-custom-list-id-container"
  );
  const createListButton = document.getElementById(
    "swym-custom-create-list-button"
  );
  const confirmListNameButton = document.getElementById(
    "swym-custom-confirm-list-button"
  );
  const createListContainer = document.getElementById("swym-custom-backdrop");
  const cancelListCreationButton = document.getElementById(
    "swym-custom-notconfirm-list-button"
  );
  const listNameInput = document.getElementById(
    "swym-custom-new-list-name-input"
  );
  const variantImage = document.getElementById("swym-custom-primary-image");
  const vendorTitle = document.getElementById("swym-custom-vendor-title");
  const productTitle = document.getElementById("swym-custom-product-title");
  const price = document.getElementById("swym-custom-variant-price");
  const variantTitle = document.getElementById("swym-custom-variant-title");
  const imgBlobContainer = document.getElementById(
    "swym-custom-image-blob-container"
  );
  const imageSliderContainer = document.getElementById(
    "swym-custom-images-slide-container"
  );
  const prevButton = document.getElementById("swym-custom-slide-arrow-prev");
  const nextButton = document.getElementById("swym-custom-slide-arrow-next");

  let arrayOfSwymCollectionsButtons;
  let variantImagesArray;
  let productData;
  let productURL;
  let productEvent;
  let selectedVariant = {};
  let currentVariantId;
  let globalActionArray = [];
  let globalListArray = [];
  let globalProductsInListArray = [];
  let selectCallBackObj = [];
  let pdInWishlist = false;
  let hasBoundModalControls = false;
  let hasBoundBackdropClick = false;
  const translationsObject = {
    english: {
      defaultWishlistTitle: themeSettings.defaultWishlistTitle,
      desktopModalTitle: themeSettings.desktopModalTitle,
      addedToSingleList: themeSettings.addedToSingleList,
      addedToMultipleLists: themeSettings.addedToMultipleLists,
      selectPreferenceText: themeSettings.selectPreferenceText,
      selectWishlistText: themeSettings.selectWishlistText,
      createListButtonText: themeSettings.createListButtonText,
      createListInputPlaceHolder: themeSettings.createListInputPlaceHolder,
      addToWishlistTextNoListSelected:
        themeSettings.addToWishlistTextNoListSelected,
      addToWishlistTextAddState: themeSettings.addToWishlistTextAddState,
      addToWishlistTextUpdateState: themeSettings.addToWishlistTextUpdateState,
      singleWishlistButtonAddText: themeSettings.singleWishlistButtonAddText,
      singleWishlistButtonRemoveText:
        themeSettings.singleWishlistButtonRemoveText,
      createListModalTitle: themeSettings.createListModalTitle,
      createListGuideText: themeSettings.createListGuideText,
      confirmNewListButtonText: themeSettings.confirmNewListButtonText,
      notificationAddText: themeSettings.notificationAddText,
      notificationRemoveText: themeSettings.notificationRemoveText,
      notificationUpdateText: themeSettings.notificationUpdateText,
      listNameError: themeSettings.listNameError,
      listNameNotUniqueError: themeSettings.listNameNotUniqueError,
      listLimitErrorMessage: themeSettings.listLimitErrorMessage,
    },
  };

  const currentLanguageOption = translationsObject[currentLanguage]
    ? translationsObject[currentLanguage]
    : translationsObject["english"];
  const defaultWishlistTitle = currentLanguageOption.defaultWishlistTitle;

  (function addTextToModal() {
    desktopModalTitle.textContent = currentLanguageOption.desktopModalTitle;
    selectPreferenceText.textContent =
      currentLanguageOption.selectPreferenceText;
    selectListsText.textContent = currentLanguageOption.selectWishlistText;
    createListButton.textContent = currentLanguageOption.createListButtonText;
    createListGuideText.textContent = currentLanguageOption.createListGuideText;
    createListModalTitle.textContent =
      currentLanguageOption.createListModalTitle;
    confirmListNameButton.textContent =
      currentLanguageOption.confirmNewListButtonText;
    listNameInput.setAttribute(
      "placeholder",
      currentLanguageOption.createListInputPlaceHolder
    );
  })();

  function debounce_leading(func, timeout = 300) {
    let timer;
    return (...args) => {
      if (!timer) {
        func.apply(this, args);
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = undefined;
      }, timeout);
    };
  }

  function customErrorHandling(error) {
    swat.ui.uiRef.showErrorNotification({ message: error });
  }

  function customSuccessHandling(success) {
    swat.ui.uiRef.showSuccessNotification({ message: success });
  }

  async function persistWishlistButtonsState() {
    return new Promise((resolve, reject) => {
      let onSuccess = function (lists) {
        globalListArray = lists;
        lists.forEach((list) => {
          list.listcontents.forEach((product) => {
            let productId = product.empi;
            let buttonsToFill = document.querySelectorAll(
              `button#swym-collections[data-product-id="${productId}"]`
            );

            buttonsToFill.forEach((button) => {
              if (!button.classList.contains("swym-added")) {
                button.classList.add("swym-added");
              }
            });
          });
        });
        resolve();
      };

      let onError = function (error) {
        console.error("Error while fetching all Lists", error);
        reject(error);
      };

      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      });
    });
  }

  async function handleRemoveFromWishlistButtonState(productId) {
    try {
      await persistWishlistButtonsState();
      const productIdExistsInSomeList = globalListArray.some((list) =>
        list.listcontents.some((product) => product.empi === productId)
      );

      if (!productIdExistsInSomeList) {
        const buttonToUnFill = document.querySelectorAll(
          `button#swym-collections[data-product-id="${productId}"]`
        );

        buttonToUnFill.forEach((button) => {
          if (button) {
            SwymUtils.removeClass(button, "swym-added");
          }
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  function handleAddedToWishlistButtonState(productId) {
    let buttonToFill = document.querySelectorAll(
      `button#swym-collections[data-product-id="${productId}"]`
    );
    buttonToFill.forEach((button) => {
      if (button && !button.classList.contains("swym-added")) {
        SwymUtils.addClass(button, "swym-added");
      }
    });
  }

  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (data) {
      let productId = data.detail.d.empi;
      handleRemoveFromWishlistButtonState(productId);
    }
  );
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (data) {
      let productId = data.detail.d.empi;
      handleAddedToWishlistButtonState(productId);
    }
  );

  // function showZoomedView(e) {
  //   const zoomedView = document.createElement("div");
  //   const zoomedImage = new Image();
  //   SwymUtils.addClass(zoomedView, "zoomed-image");
  //   zoomedImage.src = e.target.src;
  //   zoomedView.appendChild(zoomedImage);

  //   const closeButton = document.createElement("button");
  //   closeButton.setAttribute("aria-label", "Close zoomed image");
  //   closeButton.classList.add("swym-zoomed-image-close-button", "close-button");
  //   closeButton.innerHTML = "&times;";
  //   closeButton.addEventListener("click", () => {
  //     document.body.removeChild(zoomedView);
  //   });
  //   zoomedView.appendChild(closeButton);

  //   document.body.appendChild(zoomedView);

  //   zoomedView.addEventListener("click", (event) => {
  //     if (event.target === zoomedView) {
  //       document.body.removeChild(zoomedView);
  //     }
  //   });
  // }

  function addImgBlobClickListener(event) {
    const imgBlobSrc = event.target.getAttribute("src");
    const allImgBlobs = document.querySelectorAll("#swym-custom-image-blob");
    variantImage.src = imgBlobSrc;

    allImgBlobs.forEach((imgBlob) => {
      if (imgBlob !== event.target) {
        imgBlob.classList.remove("selected");
      }
    });

    SwymUtils.toggleClass(event.target, "selected");
  }

  // function addImageSliderEventListeners() {
  //   const slide = document.querySelector(".swym-custom-slider-image");
  //   nextButton.addEventListener("click", () => {
  //     const slideWidth = slide.getBoundingClientRect().width;
  //     imageSliderContainer.scrollLeft += slideWidth;
  //     console.log("slideWidth next", slideWidth);
  //   });

  //   prevButton.addEventListener("click", () => {
  //     const slideWidth = slide.getBoundingClientRect().width;
  //     imageSliderContainer.scrollLeft -= slideWidth;
  //     console.log("Prev slideWidth", slideWidth);
  //   });
  // }

  function initializeSwipeableImageSlider() {
    let imageSlides = [];

    variantImagesArray.forEach((image, index) => {
      const imageSlide = document.createElement("img");
      imageSlide.src = image.src;
      imageSlide.ariaLabel = `product-image-${index}`;
      imageSlide.className = "swym-custom-slider-image";
      imageSlide.width = "250";
      imageSlide.height = "250";
      // imageSlide.addEventListener("click", showZoomedView);

      imageSlides.push(imageSlide);
      imageSliderContainer.appendChild(imageSlide);
    });

    // addImageSliderEventListeners();
  }

  function addImageCarousel() {
    // console.log("productData", productData);
    variantImagesArray = productData.product.images;
    initializeSwipeableImageSlider();
    const imgTags = variantImagesArray.map((image, index) => {
      const imgTag = document.createElement("img");
      imgTag.width = "24";
      imgTag.height = "24";
      imgTag.ariaLabel = `Product Secondary Image-${index}`;
      imgTag.id = `swym-custom-image-blob`;
      imgTag.src = image.src;

      imgTag.addEventListener("click", addImgBlobClickListener);

      return imgTag;
    });

    imgBlobContainer.innerHTML = "";
    imgBlobContainer.append(...imgTags);
  }

  function updateListHandler() {
    let listInputs = document.querySelectorAll(".swym-custom-list-button");
    globalActionArray = [];
    listInputs.forEach((input) => {
      if (!input.checked && input.classList.contains("variant-in-wishlist")) {
        globalActionArray.push({
          actionType: "remove",
          listId: `${input.getAttribute("data-list-id")}`,
        });
      } else if (
        input.checked &&
        !input.classList.contains("variant-in-wishlist")
      ) {
        globalActionArray.push({
          actionType: "add",
          listId: `${input.getAttribute("data-list-id")}`,
        });
      }
    });
    toggleAddToWishlistButtonState();
  }

  function isVariantPresentInLists(target) {
    if (!isSingleWishlist) {
      // console.log("isVariantPresentInLists if target", target);
      globalListArray.forEach((list) => {
        const listId = list.lid;
        const listInput = document.querySelector(
          `.swym-custom-list-button[data-list-id="${listId}"]`
        );
        const variantIsPresent =
          listInput &&
          list.listcontents.some((variant) => variant.epi === currentVariantId);

        if (listInput) {
          listInput.checked = variantIsPresent;
          listInput.classList.toggle("variant-in-wishlist", variantIsPresent);
        }
      });
    } else {
      // console.log("isVariantPresentInLists else target", target?.id);
      const variantInWishlist = globalProductsInListArray.some(
        (product) => product.epi === currentVariantId
      );

      addToWishlistButton.classList.toggle(
        "variant-in-wishlist",
        variantInWishlist
      );
      addToWishlistButton.textContent = variantInWishlist
        ? currentLanguageOption.singleWishlistButtonRemoveText
        : currentLanguageOption.addToWishlistTextAddState;
      pdInWishlist = variantInWishlist;
      // console.log("variantInWishlist", variantInWishlist);
      if (variantInWishlist) {
        document.querySelector(".added-your-product").innerHTML =
          "Already added to your wishlist";
      } else {
        document.querySelector(".added-your-product").innerHTML =
          "Added to your wishlist";
      }
    }
    toggleAddToWishlistButtonState();
  }

  function listSelectionEventlistener() {
    const listInputs = document.querySelectorAll(".swym-custom-list-button");
    listInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        if (e.target.classList.contains("selected")) {
          e.target.classList.remove("selected");
        } else {
          e.target.classList.add("selected");
        }
        updateListHandler();
      });
    });
    isVariantPresentInLists();
  }

  function addWishlists(target) {
    if (!isSingleWishlist) {
      // console.log("addWishlists if target", target);
      multipleListParentContainer.classList.remove("swym-hide-container");
      createListButton.classList.remove("swym-hide-container");

      const onSuccess = (lists) => {
        globalListArray = lists;
        const listItemsHTML = lists
          .map(
            (list) => `
                    <div id="swym-input-and-label-wrapper">
                        <input id="${list.lid}-${productData.product.id}" aria-label="Select ${list.lname}" class="swym-custom-list-button" type="checkbox" data-list-id="${list.lid}">
                        <label class="swym-custom-list-label" aria-label="Select ${list.lname}" data-list-id="${list.lid}" for="${list.lid}-${productData.product.id}">${list.lname} (${list.listcontents.length})</label>
                    </div>`
          )
          .join("");

        listIdContainer.innerHTML = listItemsHTML;

        listSelectionEventlistener();
        isVariantPresentInLists();

        if (globalListArray.length < 1) {
          createListButton.click();
        }

        toggleVariantData();
      };

      const onError = (error) => customErrorHandling(error.description);

      swat.fetchLists({ callbackFn: onSuccess, errorFn: onError });
    } else if (isSingleWishlist) {
      // console.log("addWishlists else target", target);
      swat.fetch(
        (allWishlistedProducts) => {
          globalProductsInListArray = allWishlistedProducts;
          isVariantPresentInLists(target);
        },
        (error) => customErrorHandling(error.description)
      );

      toggleVariantData();
    }
  }

  function toggleVariantData() {
    getSelectedVariant(selectCallBackObj);

    const currentProductTitle = productData.product.title;
    const currentProductVendor = productData.product.vendor;
    const alterNateVariantImages = productData.product.images;
    const currentVariantTitle = selectedVariant.title.replace(/\//g, "");
    const currentVariantPrice = swat.currency + " " + selectedVariant.price;
    const imageId = selectedVariant.image_id;

    // vendorTitle.innerHTML = "By: " + currentProductVendor;
    productTitle.innerHTML = currentProductTitle;
    variantTitle.innerHTML = currentVariantTitle;
    price.innerHTML = currentVariantPrice;

    for (let i = 0; i < alterNateVariantImages.length; i++) {
      if (alterNateVariantImages[i].id == imageId) {
        variantImage.setAttribute("src", alterNateVariantImages[i].src);
      } else {
        variantImage.setAttribute("src", productData.product.image.src);
      }
    }
  }

  function addProductData(productData, target) {
    // console.log("addProductData target", target.id);
    const product = productData.product;
    variantImage.src = product.image.src;
    // vendorTitle.innerHTML = product.vendor;
    productTitle.innerHTML = product.title;
    price.innerHTML = product.variants[0].price;

    addWishlists(target);
    addImageCarousel();
    renderVariantSelectors(productData);
  }

  (function () {
    function showCreateListContainer() {
      const newWishlistTitle =
        defaultWishlistTitle + (globalListArray.length + 1);

      if (globalListArray.length >= 10) {
        customErrorHandling(currentLanguageOption.listLimitErrorMessage);
      } else {
        createListContainer.classList.remove("swym-hide-container");
        createListButton.setAttribute("disabled", true);
        listNameInput.value = newWishlistTitle;
        listNameInput.select();
      }
    }

    function hideCreateListContainer() {
      createListContainer.classList.add("swym-hide-container");
      createListButton.removeAttribute("disabled");
    }

    createListButton.addEventListener("click", showCreateListContainer);
    cancelListCreationButton.addEventListener("click", hideCreateListContainer);

    createListContainer.addEventListener("click", (e) => {
      if (e.target === createListContainer) {
        hideCreateListContainer();
      }
    });
  })();

  (function () {
    confirmListNameButton.addEventListener("click", () => {
      const listName = listNameInput.value.trim();

      if (listName.length < 3 || listName.length > 50) {
        customErrorHandling(currentLanguageOption.listNameError);
        resetListNameInput();
      } else if (isListNameAlreadyExists(listName)) {
        const errorMessage = `${listName} ${currentLanguageOption.listNameNotUniqueError}`;
        customErrorHandling(errorMessage);
        resetListNameInput();
      } else {
        createList(listName);
      }
    });

    function resetListNameInput() {
      listNameInput.value = "";
      listNameInput.focus();
      listNameInput.select();
    }

    function isListNameAlreadyExists(name) {
      return globalListArray.some((list) => list.lname === name);
    }

    function createList(listName) {
      const listConfig = { lname: listName };

      swat.createList(
        listConfig,
        (newList) => {
          addWishlists();
          createListContainer.classList.add("swym-hide-container");
          createListButton.removeAttribute("disabled");
        },
        (error) => customErrorHandling(error.description)
      );
    }
  })();

  function toggleAddToWishlistButtonState() {
    if (!isSingleWishlist) {
      if (globalActionArray.length === 0) {
        addToWishlistButton.setAttribute("disabled", true);
        addToWishlistButton.textContent =
          currentLanguageOption.addToWishlistTextNoListSelected;
      } else {
        const hasRemoveAction = globalActionArray.some(
          (action) => action.actionType === "remove"
        );
        addToWishlistButton.removeAttribute("disabled");
        addToWishlistButton.textContent = hasRemoveAction
          ? currentLanguageOption.addToWishlistTextUpdateState
          : currentLanguageOption.addToWishlistTextAddState;
      }
    }
  }

  function updateVariantInLists() {
    const product = {
      epi: currentVariantId,
      empi: productData.product.id,
      du: productURL,
    };

    const { addToLids, removeFromLids } = separateListActions();

    if (!isSingleWishlist) {
      handleAddToLists(product, addToLids);
      handleRemoveFromLists(product, removeFromLids);
      const updateMessage = generateUpdateMessage();
      customSuccessHandling(updateMessage);
    } else {
      handleSingleWishlist(product);
    }

    closeCollectionsModal();
  }

  function separateListActions() {
    const addToLids = [];
    const removeFromLids = [];

    globalActionArray.forEach((listAction) => {
      if (listAction.actionType === "add") {
        addToLids.push(listAction.listId);
      } else if (listAction.actionType === "remove") {
        removeFromLids.push(listAction.listId);
      }
    });

    return { addToLids, removeFromLids };
  }

  function handleAddToLists(product, addToLids) {
    if (addToLids.length > 0) {
      const onSuccess = (response) => {};
      const onError = (error) => customErrorHandling(error.description);
      swat.addProductToLists(product, addToLids, onSuccess, onError);
    }
  }

  function handleRemoveFromLists(product, removeFromLids) {
    if (removeFromLids.length > 0) {
      const onSuccess = (response) => {};
      const onError = (error) => customErrorHandling(error.description);
      swat.removeProductFromLists(product, removeFromLids, onSuccess, onError);
    }
  }

  function generateUpdateMessage() {
    const listLength = globalActionArray.length;
    const listText =
      listLength > 1
        ? currentLanguageOption.addedToMultipleLists
        : currentLanguageOption.addedToSingleList;
    return `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationUpdateText} ${listLength}${listText}`;
  }

  function handleSingleWishlist(product) {
    if (!addToWishlistButton.classList.contains("variant-in-wishlist")) {
      swat.addToWishList(
        product,
        (response) => {
          const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationAddText}`;
          customSuccessHandling(updateMessage);
        },
        (error) => {}
      );
    } else {
      swat.removeFromWishList(
        product,
        (response) => {
          const updateMessage = `${productTitle.textContent} ${variantTitle.textContent} ${currentLanguageOption.notificationRemoveText}`;
          customSuccessHandling(updateMessage);
        },
        (error) => {}
      );
    }
  }

  function convertObjectToString(selectCallBackObj) {
    return Object.values(selectCallBackObj).join(" / ");
  }

  function getSelectedVariant(selectCallBackObj) {
    globalActionArray = [];
    const variants = productData.product.variants;
    let variantComboUnavailable = false;
    variants.forEach((variant) => {
      const filterTitle = convertObjectToString(selectCallBackObj);
      if (filterTitle == variant.title) {
        variantComboUnavailable = true;
        selectedVariant = variant;
        currentVariantId = variant.id;
      }
    });
    if (!variantComboUnavailable) {
      addToWishlistButton.setAttribute("disabled", true);
      addToWishlistButton.textContent = "Combination Unavailable";
    } else {
      addToWishlistButton.removeAttribute("disabled");
      addToWishlistButton.textContent = "Update List";
    }

    isVariantPresentInLists();
  }

  function handleRadioButtonClick(event) {
    const selectedValue = event.target.value;
    const optionIndex = event.currentTarget.getAttribute("optionIndex");

    selectCallBackObj = {
      ...selectCallBackObj,
      [optionIndex]: selectedValue,
    };

    const labels = event.currentTarget.parentNode.querySelectorAll(
      `label[for="${event.target.id}"]`
    );
    labels.forEach((label) => {
      label.classList.add("selected");
    });

    const unselectedRadios = event.currentTarget.parentNode.querySelectorAll(
      `input[type="radio"]:not([value="${selectedValue}"])`
    );
    unselectedRadios.forEach((radio) => {
      const labels = event.currentTarget.parentNode.querySelectorAll(
        `label[for="${radio.id}"]`
      );
      labels.forEach((label) => {
        label.classList.remove("selected");
      });
    });

    toggleVariantData();
  }

  function createRadioGroup(option, optionIndex) {
    const variantOptions = option.values
      .map((value) => {
        const isSelected = value == selectedVariant[`option${optionIndex + 1}`];
        return `<input style="display: none;" selected="${isSelected}" id="${option.name}-${value}" type="radio" name="${option.name}" optionIndex="${optionIndex}" value="${value}" aria-label="${option.name} ${value}"></input>
                        <label class="swym-filter-labels" for="${option.name}-${value}">${value}</label>`;
      })
      .join("");

    const radioGroup = document.createElement("div");
    radioGroup.setAttribute("class", `${option.name} swym-filter-option-name`);
    radioGroup.innerHTML = `<div id="swymOptionName" selected value="${
      option.name
    }">Select a ${option.name?.toLowerCase()}</div>
                                  <div class="swym-radio-buttons-container">${variantOptions}</div>`;

    const radioButtons = radioGroup.querySelectorAll(`[name="${option.name}"]`);
    for (let i = 0; i < radioButtons.length; i++) {
      radioButtons[i].addEventListener("click", function (event) {
        handleRadioButtonClick(event, productData);
        // console.log("click label", event.target);
      });
    }

    return radioGroup;
  }

  function renderVariantSelectors() {
    const optionsArray = productData.product.options;
    // console.log("productData", productData);
    const variantSelectors = optionsArray.map((option, optionIndex) => {
      return createRadioGroup(option, optionIndex);
    });

    variantSelectionContainer.innerHTML = "";
    variantSelectors.forEach((variantSelector) => {
      variantSelectionContainer.append(variantSelector);
    });

    // Initialise the first option for each selector WITHOUT firing click events.
    // Previously, radioButtons[0].click() was used here, but that dispatched a
    // real DOM click which could propagate to the label's click listener and
    // trigger the wishlist-add setTimeout for variant 1. When the user then
    // clicked a different variant, a second setTimeout fired for that variant,
    // causing both variant 1 and the chosen variant to be added to the wishlist.
    variantSelectors.forEach((variantSelector) => {
      const radioButtons = variantSelector.querySelectorAll(
        'input[type="radio"]'
      );
      if (radioButtons.length > 0) {
        const firstRadio = radioButtons[0];
        const optionIndex = firstRadio.getAttribute("optionIndex");

        // Check the radio imperatively – no click event, no label side-effects.
        firstRadio.checked = true;

        // Keep selectCallBackObj in sync so getSelectedVariant works correctly.
        selectCallBackObj = {
          ...selectCallBackObj,
          [optionIndex]: firstRadio.value,
        };

        // Apply the "selected" visual state to the matching label only.
        variantSelector
          .querySelectorAll("label.swym-filter-labels")
          .forEach((label) => {
            if (label.getAttribute("for") === firstRadio.id) {
              label.classList.add("selected");
            } else {
              label.classList.remove("selected");
            }
          });
      }
    });

    // Update price/title/image once after all options are initialised.
    toggleVariantData();

    document
      .querySelectorAll(".swym-filter-labels")
      .forEach(function (element) {
        element.addEventListener("click", function () {
          var thisLabel = this;
          const prodName = thisLabel
            .closest("#swym-custom-collections-modal-parent")
            .querySelector("#swym-custom-product-title")?.textContent;

          const prodPrice = thisLabel
            .closest("#swym-custom-collections-modal-parent")
            .querySelector("#swym-custom-variant-price")?.textContent;
          document
            .querySelector(".added-your-product")
            .classList.remove("hide");
          document
            .querySelector(".swym-radio-buttons-container")
            .classList.add("var-option");
          // let addWishlistBtn = document
          //   .getElementById("swym-custom-add-to-wishlist-button")
          //   .classList.contains("variant-in-wishlist");
          // let addMessageSelector = document.querySelector(
          //   ".added-your-product"
          // );
          // addWishlistBtn
          //   ? (addMessageSelector.innerHTML = "Already added to your wishlist")
          //   : (addMessageSelector.innerHTML = "Added to your wishlist");

          // console.log(pdInWishlist, "pdInWishlist");
          setTimeout(function () {
            // console.log(pdInWishlist, "pdInWishlist settimeopout");
            if (!pdInWishlist) {
              document
                .getElementById("swym-custom-add-to-wishlist-button")
                .click();

              // let modalParent = this.closest(
              //   "#swym-custom-collections-modal-parent"
              // );

              let pdIndex = Array.from(
                document.querySelectorAll(".swym-add-to-wishlist-view-product")
              ).indexOf(this);

              window.dataLayer = window.dataLayer || [];
              dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
              dataLayer.push({
                event: "add_to_wishlist",
                ecommerce: {
                  currency: "GBP", //the user's currency
                  value: prodPrice?.replace("£", ""), //the product price
                  items: [
                    {
                      item_id: thisLabel.getAttribute("data-variant-id"), // the product ID
                      item_name: prodName, // the product name
                      index: pdIndex + 1, // the position
                      item_brand: "daals",
                      item_category:
                        thisLabel.getAttribute("data-product-type"),
                      item_list_name: location.pathname, // dynamic, the list name
                      item_variant: thisLabel.getAttribute("data-pd-var-title"), // dynamic, the variant added to wish list
                      item_product_id:
                        thisLabel.getAttribute("data-product-id"),
                      item_variant_id:
                        thisLabel.getAttribute("data-variant-id"),
                      price: prodPrice?.replace("£", ""), // the price of the product, same as the value
                      quantity: 1, //always static and 1
                    },
                  ],
                },
              });
            }
            document.querySelector(".added-your-product").innerHTML = "";
            document.querySelector(".added-your-product").classList.add("hide");
          }, 2000);
        });
      });
  } // end renderVariantSelectors function

  function closeCollectionsModal() {
    selectCallBackObj = {};
    swymCollectionsModal.classList.add("swym-hide-container");
    webpageBody.classList.remove("swym-modal-active");
    imageSliderContainer.innerHTML = "";
    variantSelectionContainer.innerHTML = "";
    imgBlobContainer.innerHTML = "";
    listIdContainer.innerHTML = "";
    document
      .querySelector(".swym-radio-buttons-container")
      ?.classList.remove("var-option");
  }

  function openCollectionsModal(target) {
    // console.log("openCollectionsModal target", target);
    addProductData(productData, target);

    swymCollectionsModal.classList.remove("swym-hide-container");
    // variantImage.addEventListener("click", showZoomedView);
    webpageBody.classList.add("swym-modal-active");
    globalActionArray = [];

    if (!hasBoundBackdropClick) {
      window.addEventListener("click", (event) => {
        if (event.target === swymCollectionsModal) {
          closeCollectionsModal();
        }
      });
      hasBoundBackdropClick = true;
    }
    imageSliderContainer.scrollLeft = 0;
  }

  var breakPull = 0;
  function markOutOfStock() {
    if (document.querySelectorAll(".swym-filter-labels").length > 0) {
      const rawPdUrl = productEvent;

      const urlObj = new URL(rawPdUrl);
      const pathSegments = urlObj.pathname.split("/");
      const productHandle = pathSegments[2];

      fetch(`/products/${productHandle}.js`)
        .then((res) => res.json())
        .then((productJson) => {
          var prodID = productJson.id;
          var prodType = productJson.type;
          var selectorLabels = productJson.variants;

          for (var vari = 0; vari < selectorLabels.length; vari++) {
            const isAvailable = selectorLabels[vari].available; // Returns true or false
            const variTitle = selectorLabels[vari].title;
            const variID = selectorLabels[vari].id;
            const variPrice = selectorLabels[vari].price;
            // console.log("productJson", productJson);
            var label = document.querySelector(
              `.swym-radio-buttons-container input[value="${variTitle}"]+label`
            );
            if (isAvailable == false) {
              label?.classList.add("stock-out");
            }
            label.setAttribute("data-pd-var-title", variTitle);
            label.setAttribute("data-pd-price", variPrice);
            label.setAttribute("data-variant-id", variID);
            label.setAttribute("data-product-id", prodID);
            label.setAttribute("data-product-type", prodType);
            // console.log(isAvailable, 'variation', variTitle);
          }
        });
    } else if (++breakPull < 100) {
      // console.log(document.querySelectorAll('.swym-filter-labels').length,'not found', productEvent);
      setTimeout(markOutOfStock, 200);
    }
  }

  function fetchProductDetails(event) {
    // console.log("fetchProductDetails event", event);
    const rawUrl = event.target.getAttribute("data-product-url");
    productURL = rawUrl.split("?")[0];
    const shopifyProductEndpoint = productURL + ".json";

    productEvent = event.target.getAttribute("data-product-url");

    const urlObj = new URL(rawUrl);
    const pathSegments = urlObj.pathname.split("/");
    const productHandle = pathSegments[2];
    fetch(shopifyProductEndpoint)
      .then((res) => res.json())
      .then((productJson) => {
        productData = productJson;
        selectedVariant = productData.product.variants[0];
        openCollectionsModal(event.target);
        // console.log("selectedVariant", selectedVariant);
      });

    // fetch(`/products/${productHandle}.js`)
    //   .then((res) => res.json())
    //   .then((productJson) => {
    //     productAvailableData = productJson;
    //   });

    // console.log("hiiiiiiiiiiiiiiiiii");
    // swat.fetch(function (products) {
    //   console.log("products in wishlist", products);
    // });
    setTimeout(markOutOfStock(), 1000);
  }

  const debouncedFetchProductDetails = debounce_leading(
    fetchProductDetails,
    500
  );
  const debouncedUpdateVariantInLists = debounce_leading(
    updateVariantInLists,
    500
  );

  function addEventListeners() {
    arrayOfSwymCollectionsButtons =
      document.querySelectorAll("#swym-collections");
    if (arrayOfSwymCollectionsButtons) {
      for (let i = 0; i < arrayOfSwymCollectionsButtons.length; i++) {
        if (!arrayOfSwymCollectionsButtons[i].dataset.swymCollectionsBound) {
          arrayOfSwymCollectionsButtons[i].addEventListener(
            "click",
            debouncedFetchProductDetails
          );
          arrayOfSwymCollectionsButtons[i].dataset.swymCollectionsBound =
            "true";
          SwymUtils.addClass(
            arrayOfSwymCollectionsButtons[i],
            "swym-custom-loaded"
          );
        }
      }
    }

    if (!hasBoundModalControls) {
      modalCloseButton.addEventListener("click", closeCollectionsModal);
      addToWishlistButton.addEventListener(
        "click",
        debouncedUpdateVariantInLists
      );
      hasBoundModalControls = true;
    }

    persistWishlistButtonsState();
  }

  addEventListeners();

  // console.log(document.querySelectorAll(".swym-filter-labels"), "element");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);
